import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@shui/core';
// Import Angular Material Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
// BrowserAnimationsModule has been REMOVED
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TranslatePipe } from '@ngx-translate/core';
import { NgShuiModule } from '@shui/angular';
import { HighlightPipe } from '../app/shared/pipe/highlight.pipe';
import { ClickedOutsideDirective } from './shared/directive/click-outside.directive';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    // BrowserAnimationsModule REMOVED
    MatDividerModule,
    MatTooltipModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatAutocompleteModule,
    ReactiveFormsModule,
    NgShuiModule,
    HighlightPipe,
    ClickedOutsideDirective,
    TableModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    PaginatorModule,
    SelectModule,
    TranslateModule
  ],

  exports: [
    CommonModule,
    FormsModule,
    // Material Modules
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDividerModule,
    MatTooltipModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    NgShuiModule,
    HighlightPipe,
    ClickedOutsideDirective,
    TableModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    PaginatorModule,
    SelectModule,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShareModule {}
